import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import StrategySummaryForm from "./StrategySummaryForm";
import JoyrideGlobalZIndex from "./JoyrideGlobalZIndex";

export default function StrategySummaryPage() {
  return (
    <DashboardLayout>
      <JoyrideGlobalZIndex />
      <DashboardNavbar />
      <StrategySummaryForm />
    </DashboardLayout>
  );
}
